import React from 'react'

const SortIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 1H5' stroke='#33354D' strokeLinecap='round' />
      <path d='M1 1H5' stroke='#33354D' strokeLinecap='round' />
      <path d='M7 1H15' stroke='#33354D' strokeLinecap='round' />
      <path d='M1 7H11' stroke='#33354D' strokeLinecap='round' />
      <path d='M1 13H7' stroke='#33354D' strokeLinecap='round' />
    </svg>
  )
}

export default SortIcon
